import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Beranda',
    component: () => import('../../components/views/Publik/Beranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../../components/views/Publik/Login.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KontakKami',
    name: 'KontakKami',
    component: () => import('../../components/views/Publik/KontakKami.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/MasukanSaran',
    name: 'MasukanSaran',
    component: () => import('../../components/views/Publik/MasukanSaran.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarProgramBudgeting',
    name: 'DaftarProgramBudgeting',
    component: () => import('../../components/views/Publik/DaftarProgramBudgeting.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarFinance',
    name: 'DaftarFinance',
    component: () => import('../../components/views/Publik/DaftarFinance.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarMonev',
    name: 'DaftarMonev',
    component: () => import('../../components/views/Publik/DaftarMonev.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarPDOIOS',
    name: 'DaftarPDOIOS',
    component: () => import('../../components/views/Publik/DaftarPDOIOS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarQuickStatus',
    name: 'DaftarQuickStatus',
    component: () => import('../../components/views/Publik/DaftarQuickStatus.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarAduan',
    name: 'DaftarAduan',
    component: () => import('../../components/views/Publik/DaftarAduan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Aduan',
    name: 'Aduan',
    component: () => import('../../components/views/Publik/Aduan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/FAQ',
    name: 'FAQ',
    component: () => import('../../components/views/Publik/FAQ.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/CariAduan',
    name: 'CariAduan',
    component: () => import('../../components/views/Publik/CariAduan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: () => import('../../components/views/Dashboard/Dashboard.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Regulasi',
    name: 'Regulasi',
    component: () => import('../../components/views/Backoffice/Regulasi/Regulasi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesRegulasi/:id',
    name: 'ProsesRegulasi',
    component: () => import('../../components/views/Backoffice/Regulasi/ProsesRegulasi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarRegulasi',
    name: 'DaftarRegulasi',
    component: () => import('../../components/views/Publik/DaftarRegulasi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Slider',
    name: 'Slider',
    component: () => import('../../components/views/Backoffice/Slider/Slider.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesSlider/:id',
    name: 'ProsesSlider',
    component: () => import('../../components/views/Backoffice/Slider/ProsesSlider.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Kategori',
    name: 'Kategori',
    component: () => import('../../components/views/Backoffice/Kategori/Kategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKategori/:id',
    name: 'ProsesKategori',
    component: () => import('../../components/views/Backoffice/Kategori/ProsesKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/SubKategori',
    name: 'SubKategori',
    component: () => import('../../components/views/Backoffice/SubKategori/SubKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesSubKategori/:id',
    name: 'ProsesSubKategori',
    component: () => import('../../components/views/Backoffice/SubKategori/ProsesSubKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/UnitKategori',
    name: 'UnitKategori',
    component: () => import('../../components/views/Backoffice/UnitKategori/UnitKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesUnitKategori/:id',
    name: 'ProsesUnitKategori',
    component: () => import('../../components/views/Backoffice/UnitKategori/ProsesUnitKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/InfoBeranda',
    name: 'InfoBeranda',
    component: () => import('../../components/views/Backoffice/InfoBeranda/InfoBeranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesInfoBeranda/:id',
    name: 'ProsesInfoBeranda',
    component: () => import('../../components/views/Backoffice/InfoBeranda/ProsesInfoBeranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Konten',
    name: 'Konten',
    component: () => import('../../components/views/Backoffice/Konten/Konten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKonten/:id',
    name: 'ProsesKonten',
    component: () => import('../../components/views/Backoffice/Konten/ProsesKonten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/User',
    name: 'User',
    component: () => import('../../components/views/Backoffice/User/User.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesUser/:id',
    name: 'ProsesUser',
    component: () => import('../../components/views/Backoffice/User/ProsesUser.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Monev/:id',
    name: 'Monev',
    component: () => import('../../components/views/Backoffice/Monev/Monev.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesMonev/:id',
    name: 'ProsesMonev',
    component: () => import('../../components/views/Backoffice/Monev/ProsesMonev.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesPDOMonev/:id',
    name: 'ProsesPDOMonev',
    component: () => import('../../components/views/Backoffice/Monev/ProsesPDOMonev.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/IPP',
    name: 'IPP',
    component: () => import('../../components/views/Backoffice/IPP/IPP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/GAP',
    name: 'GAP',
    component: () => import('../../components/views/Backoffice/GAP/GAP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PDOIOS',
    name: 'PDOIOS',
    component: () => import('../../components/views/Backoffice/PDOIOS/PDOIOS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesPDOIOS/:id',
    name: 'ProsesPDOIOS',
    component: () => import('../../components/views/Backoffice/PDOIOS/ProsesPDOIOS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Gesiap',
    name: 'Gesiap',
    component: () => import('../../components/views/Backoffice/Gesiap/Gesiap.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesGesiap/:id',
    name: 'ProsesGesiap',
    component: () => import('../../components/views/Backoffice/Gesiap/ProsesGesiap.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DetailProsesGesiap/:id',
    name: 'DetailProsesGesiap',
    component: () => import('../../components/views/Backoffice/Gesiap/DetailProsesGesiap.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKurvaS/:id',
    name: 'ProsesKurvaS',
    component: () => import('../../components/views/Backoffice/Monev/ProsesKurvaS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KendalaTindakLanjut/:id',
    name: 'KendalaTindakLanjut',
    component: () => import('../../components/views/Backoffice/Monev/KendalaTindakLanjut.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ImportExcel',
    name: 'ImportExcel',
    component: () => import('../../components/views/ImportExcel/ImportExcel.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/CEMP',
    name: 'CEMP',
    component: () => import('../../components/views/Backoffice/CEMP/CEMP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/RKLRPL',
    name: 'RKLRPL',
    component: () => import('../../components/views/Backoffice/RKLRPL/RKLRPL.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Sampel',
    name: 'Sampel',
    component: () => import('../../components/views/Backoffice/Sampel/Sampel.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KategoriData',
    name: 'KategoriData',
    component: () => import('../../components/views/Backoffice/KategoriData/KategoriData.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKategoriData/:id',
    name: 'ProsesKategoriData',
    component: () => import('../../components/views/Backoffice/KategoriData/ProsesKategoriData.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/AduanMasyarakat',
    name: 'AduanMasyarakat',
    component: () => import('../../components/views/Backoffice/AduanMasyarakat/AduanMasyarakat.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesAduanMasyarakat/:id',
    name: 'ProsesAduanMasyarakat',
    component: () => import('../../components/views/Backoffice/AduanMasyarakat/ProsesAduanMasyarakat.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/TindaklanjutAduanMasyarakat/:id',
    name: 'TindaklanjutAduanMasyarakat',
    component: () => import('../../components/views/Backoffice/AduanMasyarakat/TindaklanjutAduanMasyarakat.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/LayerPeta',
    name: 'LayerPeta',
    component: () => import('../../components/views/Backoffice/LayerPeta/LayerPeta.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/GIS/:id',
    name: 'GIS',
    component: () => import('../../components/views/Publik/GIS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarKonten/:id',
    name: 'DaftarKonten',
    component: () => import('../../components/views/Publik/DaftarKonten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarKegiatan',
    name: 'DaftarKegiatan',
    component: () => import('../../components/views/Publik/DaftarKegiatan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Berita',
    name: 'Berita',
    component: () => import('../../components/views/Backoffice/Berita/Berita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesBerita/:id',
    name: 'ProsesBerita',
    component: () => import('../../components/views/Backoffice/Berita/ProsesBerita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarBerita',
    name: 'DaftarBerita',
    component: () => import('../../components/views/Publik/DaftarBerita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Galeri',
    name: 'Galeri',
    component: () => import('../../components/views/Backoffice/Galeri/Galeri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesGaleri/:id',
    name: 'ProsesGaleri',
    component: () => import('../../components/views/Backoffice/Galeri/ProsesGaleri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DetailGaleri/:id',
    name: 'DetailGaleri',
    component: () => import('../../components/views/Backoffice/Galeri/DetailGaleri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarAlbum',
    name: 'DaftarAlbum',
    component: () => import('../../components/views/Publik/DaftarAlbum.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarGaleri/:id',
    name: 'DaftarGaleri',
    component: () => import('../../components/views/Publik/DaftarGaleri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Dokumen',
    name: 'Dokumen',
    component: () => import('../../components/views/Backoffice/Dokumen/Dokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesDokumen/:id',
    name: 'ProsesDokumen',
    component: () => import('../../components/views/Backoffice/Dokumen/ProsesDokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DetailDokumen/:id',
    name: 'DetailDokumen',
    component: () => import('../../components/views/Backoffice/Dokumen/DetailDokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarAlbumDokumen',
    name: 'DaftarAlbumDokumen',
    component: () => import('../../components/views/Publik/DaftarAlbumDokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarGaleriDokumen/:id',
    name: 'DaftarGaleriDokumen',
    component: () => import('../../components/views/Publik/DaftarGaleriDokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarStatus',
    name: 'DaftarStatus',
    component: () => import('../../components/views/Publik/DaftarStatus.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarEnvironmental',
    name: 'DaftarEnvironmental',
    component: () => import('../../components/views/Publik/DaftarEnvironmental.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarSocial',
    name: 'DaftarSocial',
    component: () => import('../../components/views/Publik/DaftarSocial.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarGESIAP',
    name: 'DaftarGESIAP',
    component: () => import('../../components/views/Publik/DaftarGESIAP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DataDokumen',
    name: 'DataDokumen',
    component: () => import('../../components/views/Backoffice/NewDokumen/Dokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Environment/:id',
    name: 'Environment',
    component: () => import('../../components/views/Backoffice/Environment/Environment.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesEnvironment/:id',
    name: 'ProsesEnvironment',
    component: () => import('../../components/views/Backoffice/Environment/ProsesEnvironment.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Social/:id',
    name: 'Social',
    component: () => import('../../components/views/Backoffice/Social/Social.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesSocial/:id',
    name: 'ProsesSocial',
    component: () => import('../../components/views/Backoffice/Social/ProsesSocial.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Finance/:id',
    name: 'Finance',
    component: () => import('../../components/views/Backoffice/Finance/Finance.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesDIPA/:id',
    name: 'ProsesDIPA',
    component: () => import('../../components/views/Backoffice/Finance/ProsesDIPA.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesSPM/:id',
    name: 'ProsesSPM',
    component: () => import('../../components/views/Backoffice/Finance/ProsesSPM.vue'),
    meta: {
      transition: "zoom",
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  mode: 'history',
  routes: routes,
  linkActiveClass: 'active',
})

export default router;
